import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DownloadListItem } from '../state/download-list.models';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DownloadListService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  downloadAllDocuments(documents: DownloadListItem[], fileName: string, downloadMode: string): Observable<Blob> {
    const endpoint = downloadMode === 'merged_pdf' ? 'merge' : 'zip';
    const url = `${this.apiData.apiURL}api/${this.client}/downloadcenter/${endpoint}`;
    const body = {
      filename: fileName,
      files: documents.map((doc) => {
        if (doc.type === 'asset' && doc.assetId) {
          return {
            type: 'asset',
            id: doc.assetId,
          };
        } else {
          return {
            type: 'document',
            id: doc.documentId,
            category_id: doc.categoryId,
            language: doc.language,
            ...(doc.start_page ? { start_page: doc.start_page } : {}),
            ...(doc.end_page ? { end_page: doc.end_page } : {}),
          };
        }
      }),
    };

    return this.http.post(url, body, { responseType: 'blob' });
  }
}
